import Vue from 'vue'
import { BootstrapVueIcons, BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVueIcons)

Vue.use(BootstrapVue, {
    BModal: {
        // Disables the ability to close the modal by clicking the backdrop
        noCloseOnBackdrop: true
    }
})
